import type { RouterContextType } from "@/api/permissions/permissions.api";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/service-providers/$id/alignment/_alignmentLayout/$providerType/summary/",
)({
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });

    // Alignment is a single page now; the old summary deep link lands on it.
    throw redirect({
      to: "/service-providers/$id/alignment/$providerType",
      params: { id: args.params.id, providerType: args.params.providerType },
      replace: true,
    });
  },
  component: () => null,
});
